export default "__VITE_ASSET__CLoybKC2__"